import { render } from "./ActiveStyle.vue?vue&type=template&id=04229fbc"
import script from "./ActiveStyle.vue?vue&type=script&lang=ts"
export * from "./ActiveStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script